/**
 * connectClaudeApi — "Connect your Claude" (SUN-85): a person's own Claude desktop app
 * signs in to AURA (OAuth) and then uses AURA through the MCP connector at /api/kiaan/mcp.
 */
import { kiaanHttp } from './kiaanApi';

export interface ClaudeConnection {
  id: string;
  name: string;
  connectedAt: string;
  lastUsedAt: string;
  expiresAt: string | null;
}

const data = <T,>(body: unknown): T => (body as { data: T }).data;

/** The text the server sent back, or a plain fallback. */
export function connectErrorText(err: unknown): string {
  const e = err as { response?: { status?: number; data?: { error?: string } } } | null;
  if (e?.response?.status === 401) return 'Your AURA sign-in has ended. Sign in again.';
  return e?.response?.data?.error || 'AURA could not do that right now. Try again.';
}

/** `/api/kiaan/mcp` on this site — what you paste into Claude. */
export function connectorUrl(): string {
  return `${window.location.origin}/api/kiaan/mcp`;
}

export async function getClaudeRequest(search: string): Promise<{ clientName: string; redirectHost: string }> {
  return data((await kiaanHttp.get(`/mcp-connect/request${search}`)).data);
}

export async function answerClaudeRequest(allow: boolean, params: Record<string, string>): Promise<string> {
  const res = await kiaanHttp.post(allow ? '/mcp-connect/approve' : '/mcp-connect/deny', params);
  return data<{ redirectTo: string }>(res.data).redirectTo;
}

export async function listClaudeConnections(): Promise<{ url: string; connections: ClaudeConnection[] }> {
  return data((await kiaanHttp.get('/mcp-connect/connections')).data);
}

export async function revokeClaudeConnection(id: string): Promise<void> {
  await kiaanHttp.post(`/mcp-connect/connections/${encodeURIComponent(id)}/revoke`);
}
